module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/icon_lead_point_plans-a446b46b669089c3798c59ee32631ffb.svg";